import { dashBoardConstants,
    nameSpace, } from "../constants/dashboard.constant";
  
  
  const initialState = {
    loading: false,
    success: false,
    request: null,
    response: null,
    error: null
  };
  
  export const getActiveCampaigns = (state = initialState, action) => {
    switch (action.type) {
      case dashBoardConstants[`ACTIVE_${nameSpace}_REQUEST`]:
        return {
          ...state,
          loading: true,
          request: action.request
        };
      case dashBoardConstants[`ACTIVE_${nameSpace}_SUCCESS`]:
        return {
          ...state,
          loading: false,
          success: true,
          response: action.response,
          error: null
        };
      case dashBoardConstants[`ACTIVE_${nameSpace}_FAILURE`]:
        return {
          ...state,
          loading: false,
          success: false,
          error: action.error
        };
      case dashBoardConstants[`ACTIVE_${nameSpace}_RESET`]:
        return {
          ...state,
          ...initialState
        };
      default:
        return state;
    }
  };
  